module.exports = __webpack_public_path__ + "static/media/base.81559ca1.png";